export default {
  badRequest: 'There was a problem with the request.',
  forbidden: 'You are not allowed to do this.',
  unauthorized: 'You do not have access to the requested resource',
  notFound: 'We could not find this.',
  internalServerError: 'There was an internal error processing your request'
};
